/* eslint-disable */
import router from '../../router/index';

export default {
    namespaced: true,
    state: {
      accessToken: null,
      access: true,
      users: [
            {
            id: 100,
            idNumber: 1122334455,
            password: 'buergerkonto',
            username: 'Daniel',
            sex: 'male',
            firstName: 'Daniel',
            lastName: 'Mustermann',
            spc: 'Peter Wolhfahrt',
            doneServices: [100,101],
            },
            {
            id: 101,
            idNumber: 5544332211,
            password: 'buergerkonto',
            username: 'Sandra',
            sex: 'female',
            firstName: 'Sandra',
            lastName: 'Musterfrau',
            spc: 'Tatjana Wiggenhauser',
            doneServices: [104,105],
            },
      ],
      activeUser: null,
    },
    mutations: {
        SET_ACCESS_TOKEN (state, token) {
            state.accessToken = token;
        },
        SET_ACCESS (state, access) {
            state.access = access;
        },
        SET_USER_SESSION (state, user) {
            state.activeUser = user;
        },
    },
    actions: {
        login({ commit, state }, { idNumber, password }) {
            const user = state.users.find(user => (user.idNumber == idNumber && user.password == password))

            if(user) {
                commit('SET_ACCESS_TOKEN', true);
                commit('SET_ACCESS', true);
                commit('SET_USER_SESSION', user);
                localStorage.setItem("userSession", JSON.stringify(user));
                localStorage.setItem("accessToken", true);

                router.push({
                    name: "CitizenAccount"
                });
            } else {
                console.error('Wrong ID Number or Password. Access denied.');
                commit('SET_ACCESS', false);
            }
        },
        refresh({ commit }) {
            const token = localStorage.getItem("accessToken");
            const user = JSON.parse(localStorage.getItem('userSession'));

            if(token && user) {
                commit('SET_ACCESS_TOKEN', true);
                commit('SET_USER_SESSION', user);
            } else {
                console.error("No AccessToken. You're not logged in");
            }
        },
        logout({ commit }) {
            commit('SET_ACCESS_TOKEN', null);
            commit('SET_ACCESS', true);
            localStorage.clear();

            router.push({
            name: "Home"
            });
        }
    },
    getters: {
        isAuthenticated: state => {
            return state.accessToken;
        },
        getUserSession: state => {
            return state.activeUser;
        },
        getAccess: state => {
            return state.access;
        },
        getUserById: state => (id) => {
            return state.users.find(user => user.id == id);
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js